// Generated by Melange

import * as Caml_exceptions from "melange.js/caml_exceptions.js";
import * as Caml_option from "melange.js/caml_option.js";

const $$Error = /* @__PURE__ */ Caml_exceptions.create("Caml_js_exceptions.Error");

function internalToOCamlException(e) {
  if (!(e == null) && Caml_exceptions.caml_is_extension(e.cause)) {
    return e.cause;
  } else {
    return {
      MEL_EXN_ID: $$Error,
      _1: e
    };
  }
}

function caml_as_js_exn(exn) {
  if (exn.MEL_EXN_ID === $$Error) {
    return Caml_option.some(exn._1);
  }
  
}

const MelangeError = (function MelangeError(message, cause) {
  var _this = Error.call(this, message, { cause: cause });

  if (_this.cause == null) {
    Object.defineProperty(_this, 'cause', {
      configurable : true,
      enumerable : false,
      writable : true,
      value : cause
    });
  }
  Object.defineProperty(_this, 'name', {
    configurable : true,
    enumerable : false,
    writable : true,
    value : 'MelangeError'
  })

  return _this;
}
);

MelangeError.prototype = Error.prototype;
;

export {
  $$Error,
  internalToOCamlException,
  caml_as_js_exn,
  MelangeError,
}
/*  Not a pure module */
